import * as React from 'react';

import * as style from '../../style.css';
import { AddButton } from '../AddButton';

export interface IHeaderRowProps {
  floating?: boolean;
  headers: React.ReactNode[];
  rowRef?: React.Ref<HTMLDivElement>;
  onClick: () => void;
}

export const HeaderRow = ({ floating = false, headers, rowRef, onClick }: IHeaderRowProps) => {
  const isShowAddBuilding = headers.length < 10;

  return (
    <div
      ref={rowRef}
      className={floating ? style['row-floating'] : style['row']}
      data-floating-header={floating ? 'true' : undefined}
      role="row"
    >
      {headers.map((header, columnIndex) => (
        <div className={style['header-cell']} key={columnIndex} role="columnheader">
          {header}
        </div>
      ))}

      {isShowAddBuilding && <AddButton floating={floating} onClick={onClick} />}
    </div>
  );
};
